import React from 'react'
import { ReactComponent as IconTrash } from "assets/images/icons/project-icons/thrash.svg";
import { ReactComponent as CloseIcon } from "assets/images/icons/close.svg";
import { ReactComponent as IconDotH } from "assets/images/icons/project-icons/dots-v.svg";

const BulkActionHandler = ({count, onCancel, onDelete, countOnly, loading, deleteText, hideThreeDot}) => {
	return (
			<div className='flex items-center space-x-2'>
					{
						!hideThreeDot && (
							<IconDotH className='text-[#cccccc] text-opacity-20' style={{height: "20px"}} />
						)
					}
					{!countOnly &&
					<>
					<button onClick={onDelete} className="flex items-center text-red-500 dropdown-item dropdown-item-icon">
						<IconTrash style={{height: "1.375rem", marginRight: "0.5rem"}} /> {loading ? "Deleting..." : deleteText || "Delete"}
					</button>
					<div style={{backgroundColor: "#e5e7eb", height: "1.375rem", width: '2px', marginRight: "0.5rem"}} />
					</>
					}
					<div className="flex items-center space-x-4">
						<p className="mb-0 text-[#6c757d] text-sm">{count}&nbsp;
							<span>selected</span>
						</p>
						<CloseIcon onClick={onCancel} className='text-red-500 cursor-pointer' />
					</div>
			</div>
	)
}

export default BulkActionHandler